import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { AMENITIES } from '../../../../../modules/amenities';
import Translation from '../../../../components/stateless/Translation';
import styles from './styles.scss';

const SMFacilitiesListItemInfo = ({ facility: { address, amenities } }) => {
  const displayedAmenities = amenities.slice(0, 3).map(amenity => (
    AMENITIES.find(({ test }) => test(amenity.name)) // eslint-disable-line jest/no-disabled-tests
  ));

  return (
    <div className={styles.info}>
      <h2 className={styles.title}>{address.address1}</h2>
      {address.address2 && <h3 className={`${styles.address2} ${styles.location}`}>{address.address2}</h3>}
      <h3 className={styles.location}> {address.city}, {address.state} {address.postal}</h3>
      <ul className={styles.amenities}>
        {displayedAmenities.map(amenity => (
          <li key={amenity.id}>
            <Translation
              id={`widgets.facilityAmenities.${amenity.token}`}
              defaultMessage={amenity.name}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

SMFacilitiesListItemInfo.propTypes = {
  facility: PropTypes.shape({
    address: PropTypes.shape({
      address1: PropTypes.string.isRequired,
      address2: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postal: PropTypes.string.isRequired,
    }).isRequired,
    amenities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

SMFacilitiesListItemInfo.fragments = {
  facility: gql`
    fragment SMFacilitiesListItemInfoFacility on Facility {
      address {
        address1
        address2
        city
        state
        postal
      }
      amenities {
        id
        name
      }
    }
  `,
};

export default SMFacilitiesListItemInfo;
